import { selector } from 'recoil';
import platformAtom from '../atom/platform';

import { Container } from '~/types/platform/platform';

const containers = selector<Record<string, Container>>({
  key: 'containers',
  get: ({ get }) => {
    const platform = get(platformAtom);

    return platform.containers.reduce<Record<string, Container>>((prev, container) => {
      prev[container.id] = container;
      return prev;
    }, {});
  },
});

export default containers;
